<!-- 二次封装输入框组件 -->
<template>
  <ul class="password-List">
    <li v-for="(item, i) in 6">
      <el-input
        :controls="false"
        show-password
        :ref="'pwdInput' + i"
        v-model="selfPassword[i]"
        :maxlength="1"
        @focus="focusInput(i)"
        @input="setPassword(i)"
        @keyup.delete.native="deleteHandle(i)"
      ></el-input>
    </li>
  </ul>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return { 
      selfPassword: [],
      oldPassword:[],
     };
  },
  mounted() {},
  methods: {
    // 聚焦时记录当前值
    focusInput(i){
      // console.log(this.selfPassword[i]);
      this.oldPassword[i]=this.selfPassword[i];
    },
    setPassword(i) {
      // 只允许输入数字
      if(!/^\d+$/.test(this.selfPassword[i])){
        this.selfPassword[i] = "";
        return
      }
      if (this.selfPassword[i]) {
        if (i > 4) {
          i = -1;
        }
        
        let name = "pwdInput" + (i + 1);
        this.$refs?.[name][0]?.focus();
      }else if(this.oldPassword[i]){
        if(i==0){
          i=1
        }
        let name = "pwdInput" + (i - 1);
        this.$refs?.[name][0]?.focus();
      }
      this.$emit("setPwdVal", this.selfPassword.join(''));
    },
    //点击删除键盘 清除当前输入框内容 并且将焦点移到前一个输入框
    deleteHandle(index) { 
    
      for (let i = 5; i >= 0; i--) {
        // if()
        if (this.selfPassword[i]) {
          this.selfPassword[i] = "";
          let name = "pwdInput" + i;
          this.$refs?.[name][0]?.focus();
          break;
        }else{
          let name = "pwdInput" + i;
          this.$refs?.[name][0]?.focus();
        }
      }
    },
  },
};
</script>
<style lang="scss" >
.password-List {
  padding: 0;
  margin: 0px;
  display: flex;
  li {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .el-input__inner {
    // background-color: rgba(0, 0, 0, 0.2);
    // border: 1px solid #473420;
    // color: white;
    padding: 0;
    text-align: center;
  }
  .el-input,
  .el-input__inner {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
  .el-input__suffix {
    display: none;
  }
}
</style>
